import React from 'react';
import DashboardLayout from './DashboardLayout';
import MetricCard from './MetricCard';
import ComplaintsTable from './ComplaintsTable';
import ComplaintsChart from './ComplaintsChart';
import CategoryComplaints from './CategoryComplaints';
import { useGetComplaintsDashboardCountQuery } from '../../redux/complaintApi';
import { useAuth } from '../../context/AuthContext';
import {
  complaintsListLink,
  statusFromDashboardCountKey,
} from '../../utils/complaintListFilters';

const pickCount = (payload, keys = [], fallback = 0) => {
  for (const k of keys) {
    const v = payload?.[k];
    if (v == null || v === '') continue;
    const n = Number(v);
    if (!Number.isNaN(n)) return n;
  }
  return fallback;
};

function AdminDashboard() {
  const { can, area } = useAuth();
  const { data: dashboardCountRes, isLoading } = useGetComplaintsDashboardCountQuery();
  const counts = dashboardCountRes?.data ?? dashboardCountRes ?? {};

  const metric = (title, countKeys) => {
    const status = statusFromDashboardCountKey(countKeys[0]);
    return {
      title,
      value: isLoading ? '—' : String(pickCount(counts, countKeys)),
      to: complaintsListLink(area, status),
    };
  };

  const metrics = [
    can('complaints') ? metric('Total Complaints', ['total_complaints']) : null,
    can('complaints') ? metric('Resolved Complaints', ['resolved_complaints']) : null,
    can('complaints')
      ? metric('In-Progress Complaints', ['inprogress_complaints'])
      : null,
    can('complaints') ? metric('Overdue Complaints', ['overdue_complaints']) : null,
  ].filter(Boolean);

  return (
    <DashboardLayout title="Dashboard">
      <div className="space-y-6 py-4">

        {metrics.length > 0 ? (
          <div className="grid grid-cols-2 gap-3 lg:grid-cols-4 lg:gap-4">
            {metrics.map((m, i) => (
              <MetricCard key={i} title={m.title} value={m.value} to={m.to} />
            ))}
          </div>
        ) : null}

        {can('complaints') ? (
          <div className="grid gap-6 lg:grid-cols-[2fr_1fr]">
            <div className="min-w-0">
              <ComplaintsChart />
            </div>
            <div className="min-w-0">
              <CategoryComplaints />
            </div>
          </div>
        ) : null}

        {can('complaints') ? (
          <div className="grid gap-6">
            <div className="min-w-0">
              <ComplaintsTable
                showRaisedBy={true}
                showViewAll={true}
                viewAllPath="/dashboard/admin/complaints"
              />
            </div>
          </div>
        ) : null}
      </div>
    </DashboardLayout>
  );
}

export default AdminDashboard;
